import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Notificacion`

export function buscarPorMensaje(idUsuarioChat, pageNumber = 1, pageSize = 0) {
  return http.get(`${API_ENDPOINT}/BuscarPorMensaje/${idUsuarioChat}`, {
    params: { pageNumber, pageSize },
    meta: {
      toastMessage: 'Ocurrió un error al obtener las notificaciones.',
      tipoError: 'notificacion'
    }
  })
}
export function actualizarNotificacion(idMensaje) {
  return http.put(API_ENDPOINT, idMensaje)
}

export function marcarTodas(idUsuarioChat, leido, idMensajes = null) {
  return http.put(
    `${API_ENDPOINT}/MarcarTodas`,
    { idUsuarioChat, leido, idMensajes },
    {
      meta: {
        toastMessage: 'Ocurrió un error al actualizar las notificaciones.',
        tipoError: 'notificacion'
      }
    }
  )
}
